import {makeAutoObservable, runInAction} from "mobx";
import {authAPI} from "./api";
import {sessionStore} from "@services/session";
import {getValueFromLocalStorage, setValueToLocalStorage} from "@shared/helpers/localstorage.helper";

export interface IUserData {
    email: string,
    password: string
}

export interface IUserRegistrationData {
    email: string,
    password: string
    nickname: string
}

export interface IResponseUserData {
    id: number
    email: string
    token: string
}

export interface AuthMeI {
    authId: number | null
    email: string | null
    isAuth: boolean
}


export class RegistrationStore {

    sessionStore

    email = ''
    nickname = ''
    password = ''
    repeatedPassword = ''

    isNicknameExist = false
    isValidKey = false
    registrationKey = getValueFromLocalStorage('regKey') || ''
    registrationKeys = []


    isCheckedEnter = false

    isLoading = true

    constructor() {
        makeAutoObservable(this);
        this.sessionStore = sessionStore
    }

    setEmail = (email: string) => {
        this.email = email
    }

    setPassword = (password: string) => {
        this.password = password
    }

    setRepeatedPassword = (password: string) => {
        this.repeatedPassword = password
    }

    setNickname = (nickname: string) => {
        this.nickname = nickname
    }

    get hasAllowRegistration() {
        // const validEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.email)
        return this.password.length > 5
            && this.nickname.length > 1
            && !this.isNicknameExist
            && this.repeatedPassword === this.password
    }

    checkingExistNickname = async () => {
        try {
            const data = await authAPI.checkingExistNickname(this.nickname)
            runInAction(() => {
                this.isNicknameExist = false
            })
            return data
        } catch (e) {
            console.log(e)
            runInAction(() => {
                this.isNicknameExist = true
            })
        }

    }

    generateRegistrationKey = async () => {
        try {
            const data = await authAPI.generateRegistrationKey()
            runInAction(() => {
                this.registrationKeys = data
            })
        } catch (e) {
            console.log(e)
        }
    }

    getRegistrationKeys = async () => {
        try {
            const data = await authAPI.getRegistrationKeys()
            runInAction(() => {
                this.registrationKeys = data
            })
        } catch (e) {
            console.log(e)
        }
    }

    deleteRegistrationKey = async (key) => {
        try {
            const data = await authAPI.deleteRegistrationKey(key)
            runInAction(() => {
                this.registrationKeys = data
            })
        } catch (e) {
            console.log(e)
        }
    }

    clearRegistrationKeys = () => {
        this.registrationKeys = []
    }

    checkingValidKey = async (key: string) => {
        try {

            const keyReg = this.registrationKey || key

            console.log('key', keyReg)

            const data = await authAPI.checkingValidKey(keyReg)
            if (data) {
                setValueToLocalStorage('regKey', data)
            }
            runInAction(() => {
                this.registrationKey = data
                this.isValidKey = keyReg === data
            })
            return data
        } catch (e) {
            console.log(e)
            // this.isValidKey = false
        }
    }

    registration = async () => {
        try {
            const userData = {
                email: this.email,
                password: this.password,
                nickname: this.nickname,
                key: this.registrationKey
            }
            const data = await authAPI.register(userData)
            sessionStore.setSession(data)
        }catch (e) {
            console.log(e)
        }
    }

}

export const registrationStore = new RegistrationStore()